<template>
  <nav>
    <div class="content-wrapper">
      <div class="left">
        <!-- Create mode  -->
        <template v-if="isCreateMode">
          <!-- Indicator of the type of project -->
          <div class="type-of-project">
            <span>Create new</span>
            <img
              :src="require(`@/assets/icons/ui/icon_${typeOfProject}.svg`)"
              :alt="typeOfProject + 'icon'"
            />
            <!-- <component :is="typeOfProject + 'SVG'"></component> -->
            <span>{{ typeOfProject }}</span>
          </div>
        </template>

        <template v-if="dealerMode && !isCreateMode">
          <button id="dealer-mode-indicator" class="background-none">
            <img
              src="@/assets/icons/ui/person-circle-outline.svg"
              alt="dealer mode icon"
            />
            Dealer Mode
          </button>

          <button
            id="log-out"
            class="background-none"
            @click="dealerLogout"
          >
            <img src="@/assets/icons/ui/exit-outline.svg" alt="Log out icon" />
            Log out
          </button>
        </template>
      </div>

      <div class="right">
        <!-- Save indicator -->
        <transition name="fade">
          <div v-if="showSaveIndicator" class="save-indicator">
            <transition name="fade">
              <p v-if="loading"><span>Saving...</span></p>
              <p v-else>
                <span>Saved </span>
                <img src="@/assets/icons/ui/save-circle.svg" alt="saved icon" />
              </p>
            </transition>
          </div>
        </transition>

        <!-- Create mode  -->
        <template v-if="isCreateMode">
          <button @click="$emit('publishProject')">
            <img
              src="@/assets/icons/ui/checkmark-outline.svg"
              alt="check as finished"
            />
            Mark as Finished
          </button>
        </template>
        <!-- Edit mode  -->
        <template v-if="!isCreateMode">
          <template v-if="!hideEditButton">
            <!-- Show Save changes if the Sidebar is open, otherwise show an 'Edit' button -->
            <!-- Save changes -->
            <button
              id="nav-save-changes"
              v-if="isEditMode"
              @click="handleClearEditMode"
            >
              <img
                src="@/assets/icons/ui/checkmark-circle-outline.svg"
                alt="checkmark"
              />
              save changes
            </button>
            <!-- Set edit mode -->
            <button id="nav-edit-button" v-else @click="handleSetEditMode()">
              <img
                src="@/assets/icons/ui/eye-outline-white.svg"
                alt="edit icon"
              />
              Edit
            </button>
          </template>

          <button id="copy-url" @click="$emit('openShareProjectModal')">
            <img src="@/assets/icons/ui/copy-outline.svg" alt="copy url icon" />
            Copy URL
          </button>
        </template>

        <!-- Export to PDF  -->
        <template>
          <button
            @click="setExportPDFMode(1)"
            v-if="!isSidebarOpen && !tempDisablePDF"
          >
            Export to PDF
          </button>
        </template>
      </div>
    </div>
    <ProjectProgressBar v-if="isCreateMode" :stepsCompleted="stepsCompleted" />
    <ModalAlert
      v-if="showModalAlert"
      :text="'Are you sure to go back? All your changes will be lost'"
      :title="'Leaving ' + typeOfProject"
      :showButtons="true"
      :confirmationText="'Yes, go back'"
      :cancelText="'No, keep editing'"
      @confirm="handleBackToDashboard"
      @cancel="showModalAlert = false"
      @closeModal="showModalAlert = false"
    />
  </nav>
</template>

<script>
import ModalAlert from "@/components/Utils/ModalAlert.vue";
import ProjectProgressBar from "@/components/Projects/Project/ProjectProgressBar";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "ProjectNavbar",
  props: [
    "hideEditButton",
    "isCreateMode",
    "isEditMode",
    "isSidebarOpen",
    "stepsCompleted",
    "typeOfProject",
  ],
  components: {
    ModalAlert,
    ProjectProgressBar,
  },

  data() {
    return {
      showModalAlert: false,
      tempDisablePDF: true,
    };
  },

  computed: {
    ...mapState("project", ["showSaveIndicator", "loading"]),
    ...mapGetters("project", ["projectStatus"]),
    ...mapState("auth", ["isAuthorizedToUseDashboard", "dealerMode"]),
  },
  methods: {
    ...mapActions("auth", ["dealerLogout"]),
    ...mapActions("project", [
      "setEditMode",
      "setPreviewMode",
      "setExportPDFMode",
      "publishProject",
    ]),

    handleBackToDashboard() {
      this.$router.push({ name: "Homepage" });
    },

    handleSetEditMode() {
      this.$emit("openSidebar");
      this.setEditMode();
    },

    async handleClearEditMode() {
      this.$emit("closeSidebar");
      this.setPreviewMode();

      //The dealer is editing the project, and maybe it is not published yet and it still has the "Draft" status
      if (this.dealerMode && this.projectStatus?.toLowerCase() === "draft") {
        await this.publishProject();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
nav {
  display: flex;
  flex-direction: column;
  height: 4rem;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 100;
  .content-wrapper {
    background: #808080;
    //padding: 1rem 2rem 1rem 1rem;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  /* General styles for buttns */
  button {
    display: flex;
    align-items: center;
    background: $grey-darker;
    color: white;
    padding: 0.5rem;
    text-transform: capitalize;
    height: 2.6rem;

    &.background-none {
      background: transparent;
    }

    img {
      margin: 0 0.5rem;
      width: 15px;
      height: 15px;
    }
  }

  .left {
    display: flex;
    width: 35%;

    button.back {
      background: none;
      color: $placeholder;

      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 6rem;
      padding: 0.25rem 1.5rem 0.25rem 0.25rem;
      border-right: 1px solid $placeholder !important;
      border-radius: 0 !important;
      transition: 0.2s;
      &:hover {
        transform: scale(1.05);
      }
    }

    .type-of-project {
      display: flex;
      align-items: center;
      padding: 0.25rem 0.25rem 0.25rem 1.5rem;

      span:nth-child(1) {
        color: $grey-light;
      }
      span:nth-child(3) {
        color: white;
        text-transform: capitalize;
      }

      img {
        width: 25px;
        height: 25px;
        margin: 0 0.5rem;
        /* fill: $snapsheetColor; */
        font-weight: bold;
      }
    }

    #dealer-mode-indicator {
      cursor: initial;
      &:hover {
        transform: initial;
      }
    }

    #log-out {
      color: $placeholder;
    }
  }

  .right {
    display: flex;
    align-items: center;
    gap: 1rem;
    button {
      &:hover {
        background: $green;
      }
    }

    .save-indicator {
      span {
        color: $greenSave;
        margin-right: 0.5rem;
      }
    }

    #nav-save-changes {
      background: $green;

      &:hover {
        background: $greenHover;
      }
    }

    #copy-url {
      &:hover {
        background: $grey-dark;
      }
    }
  }
}
</style>
